/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { UpdateDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner } from './update-daily-user-usage-limit200-response-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateDailyUserUsageLimit200ResponseReissue } from './update-daily-user-usage-limit200-response-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateDailyUserUsageLimit200ResponseUser } from './update-daily-user-usage-limit200-response-user';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateDailyUserUsageLimit200ResponseUserAccountGroup } from './update-daily-user-usage-limit200-response-user-account-group';

/**
 * 
 * @export
 * @interface UpdateDailyUserUsageLimit200Response
 */
export interface UpdateDailyUserUsageLimit200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'availableCurrencies': Array<UpdateDailyUserUsageLimit200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'availableMerchantCategories': Array<UpdateDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateDailyUserUsageLimit200ResponseUser}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'user': UpdateDailyUserUsageLimit200ResponseUser;
    /**
     * 
     * @type {UpdateDailyUserUsageLimit200ResponseUserAccountGroup}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'userAccountGroup'?: UpdateDailyUserUsageLimit200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200Response
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {UpdateDailyUserUsageLimit200ResponseReissue}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'reissue'?: UpdateDailyUserUsageLimit200ResponseReissue | null;
}

export const UpdateDailyUserUsageLimit200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateDailyUserUsageLimit200ResponseAvailableCurrenciesEnum = typeof UpdateDailyUserUsageLimit200ResponseAvailableCurrenciesEnum[keyof typeof UpdateDailyUserUsageLimit200ResponseAvailableCurrenciesEnum];


